import React from 'react';
import {useEffect} from '@wordpress/element';
import {Stack} from '@lapilli-ui/components';

import {useSearchContext} from "../../context";
import {PopoverWithContent} from "../../../../base/components";
import {YWCAS_HAS_AUTOCOMPLETE, YWCAS_MIN_CHARS, history, popular} from "../../../../config";

const FrontendBlock = ({has_innerBlock, has_historyBlock, has_popularBlock, children}) => {
    const {query, inputFocused, setInputFocused} = useSearchContext();
    let hide = false;
    let totBlock = 0;

    if (has_historyBlock === 'yes') {
        totBlock = 1;
    }

    if (has_popularBlock === 'yes') {
        totBlock = 2;
    }

    if (has_innerBlock <= totBlock) {
       let totToHide =0 ;
       if( 'yes' === has_historyBlock && history.length ===0 ){
           totToHide = 1;
       }

        if( 'yes' === has_popularBlock && popular.length ===0 ){
            totToHide += 1;
        }

        hide =  totBlock-totToHide === 0;

    }

    useEffect(() => {
        const checkIfClickedOutside = e => {
            const emptyBox = document.getElementsByClassName('wp-block-yith-empty-block');
            if (!(e.target.parentNode.parentNode && e.target.parentNode.parentNode.classList.contains('ywcas-input-field-wrapper'))) {
                if (emptyBox[0] && !emptyBox[0].contains(e.target)) {
                    setInputFocused(null)
                }
            }
        }
        document.addEventListener("click", checkIfClickedOutside)
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [setInputFocused]);

    if (!YWCAS_HAS_AUTOCOMPLETE || hide) {
        return null;
    }
    if (inputFocused && (query === '' || query.length < YWCAS_MIN_CHARS)) {
        return (
            <PopoverWithContent
                className="ywcas-popover-results"
                anchorRef={inputFocused}
                verticalMargin={5}
                forceMinWidth
                forceInView={false}
                fixed={true}
            >
                <Stack direction='column' spacing={4} className='wp-block-yith-empty-block'>
                    {children}
                </Stack>
            </PopoverWithContent>
        );
    }
    return null;
}

export default FrontendBlock;